export const s2_DEPRECATED = '2px';
export const s4 = '4px';
export const s8 = '8px';
export const s12_DEPRECATED = '12px';
export const s16 = '16px';
export const s24 = '24px';
export const s32 = '32px';
export const s40_DEPRECATED = '40px';
export const s48_DEPRECATED = '48px';
export const s56_DEPRECATED = '56px';
export const s64 = '64px';
export const s80_DEPRECATED = '80px';

export const spacing = {
  s2_DEPRECATED,
  s4,
  s8,
  s12_DEPRECATED,
  s16,
  s24,
  s32,
  s40_DEPRECATED,
  s48_DEPRECATED,
  s56_DEPRECATED,
  s64,
  s80_DEPRECATED,
};
